const AwardCheck = ({ color = 'white' }: { color: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4261 7.06269C14.6836 6.35423 15.3124 6 16 6C16.6876 6 17.3164 6.35423 18.5739 7.06269L20.3239 8.04861C21.6292 8.78401 22.2819 9.15171 22.6409 9.76664C23 10.3816 23 11.1316 23 12.6316V14.3684C23 15.8684 23 16.6184 22.6409 17.2334C22.2819 17.8483 21.6292 18.216 20.3239 18.9514L18.5739 19.9373C17.3164 20.6458 16.6876 21 16 21C15.3124 21 14.6836 20.6458 13.4261 19.9373L11.6761 18.9514C10.3708 18.216 9.71815 17.8483 9.35908 17.2334C9 16.6184 9 15.8684 9 14.3684V12.6316C9 11.1316 9 10.3816 9.35908 9.76664C9.71815 9.15171 10.3708 8.78401 11.6761 8.04861L13.4261 7.06269Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13 14.1667C13 14.1667 13.75 14.1667 14.5 15.5C14.5 15.5 16.8824 12.1667 19 11.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8825 19L21.5527 22.2099C21.9833 24.2723 22.1986 25.3035 21.7563 25.7923C21.3141 26.281 20.546 25.8606 19.0099 25.0198L16.7364 23.7753C16.3734 23.5766 16.1919 23.4773 16 23.4773C15.8081 23.4773 15.6266 23.5766 15.2636 23.7753L12.9901 25.0198C11.454 25.8606 10.6859 26.281 10.2437 25.7923C9.80139 25.3035 10.0167 24.2723 10.4473 22.2099L11.1175 19"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AwardCheck;
